import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, ClipboardList, List, MapPin } from 'lucide-react';

const navItems = [
  { path: '/dashboard/home',       icon: Home,          label: 'Home',       testId: 'nav-home'       },
  { path: '/dashboard/personal',   icon: Calendar,      label: 'Personal',   testId: 'nav-personal'   },
  { path: '/dashboard/attendance', icon: ClipboardList, label: 'Attendance', testId: 'nav-attendance' },
  { path: '/dashboard/browse',     icon: List,          label: 'Timetables', testId: 'nav-timetables' },
  { path: '/dashboard/rooms',      icon: MapPin,        label: 'Rooms',      testId: 'nav-rooms'      },
];

export function BottomNav() {
  const { pathname } = useLocation();

  return (
    <nav
      className="lg:hidden"
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 40,
        background: '#0A0A0A',
        borderTop: '1px solid rgba(255,255,255,.07)',
        padding: `10px 10px calc(10px + env(safe-area-inset-bottom))`,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
        {navItems.map(({ path, icon: Icon, label, testId }) => {
          const active = pathname === path;
          return (
            <Link key={path} to={path} style={{ flex: 1, display: 'flex', justifyContent: 'center', textDecoration: 'none' }}>
              <button
                data-testid={testId}
                style={{
                  display: 'flex', flexDirection: 'column',
                  alignItems: 'center', gap: 3,
                  padding: '7px 14px', cursor: 'pointer',
                  background: active ? 'rgba(20,184,166,.09)' : 'transparent',
                  border: `1px solid ${active ? 'rgba(20,184,166,.18)' : 'transparent'}`,
                  borderRadius: 12, transition: 'all .2s',
                  position: 'relative',
                }}
              >
                {/* Top indicator bar */}
                {active && (
                  <div style={{
                    position: 'absolute', top: -5,
                    left: '50%', transform: 'translateX(-50%)',
                    width: 16, height: 3,
                    borderRadius: '0 0 3px 3px',
                    background: '#14B8A6',
                    boxShadow: '0 0 8px rgba(20,184,166,.5)',
                  }} />
                )}

                <Icon
                  size={20}
                  strokeWidth={active ? 2.5 : 2}
                  color={active ? '#14B8A6' : 'rgba(255,255,255,.35)'}
                  aria-hidden
                />

                <span style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 7.5, letterSpacing: '.08em',
                  textTransform: 'uppercase', fontWeight: 500,
                  color: active ? '#14B8A6' : 'rgba(255,255,255,.25)',
                  transition: 'color .2s',
                }}>
                  {label}
                </span>
              </button>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}